var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pi-elec-echart"},[_c('div',{ref:"elecEchart",staticClass:"elec-echart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }